import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// A custom theme for this app
const theme = createTheme({
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
  palette: {
    primary: {
      main: "#103544",
    },
    secondary: {
      main: "#91BFBC",
      contrastText: "#1f7d78",
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
